/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { permissionsOutputDataRoleSchema } from './PermissionsOutputDataRoleSchema'

export const permissionsOutputDataSchema = z.object({
	role: permissionsOutputDataRoleSchema,
	permissions: z.array(z.string()),
})

export type PermissionsOutputDataSchema = z.infer<typeof permissionsOutputDataSchema>
